import {
  text1,
  text10,
  text11,
  text12,
  text13,
  text2,
  text3,
  text4,
  text5,
  text6,
  text7,
  text8,
  text9
} from './helper-content';

export const guideLine = {
    'Quy định về mã vạch sản phẩm?': text1,
    'Quy định về tên sản phẩm?' : text2,
    'Tải ảnh sản phẩm theo kích cỡ nào sẽ đẹp nhất?' : text3,
    'Cách để có video về sản phẩm đẹp nhất?' : text4,
    'Giá sản phẩm là gì?' : text5,
    'Mô tả về sản phẩm như thế nào' : text6,
    'Mô tả về Doanh nghiệp sở hữu như thế nào?' : text7,
    'Làm thế nào để người dùng dễ dàng phân biệt thật giả' : text8,
    'Kích cỡ ảnh đại diện đẹp nhất?' : text10,
    'Kích cỡ ảnh nền đẹp nhất?' : text11,
    'Kích cỡ video đẹp nhất?' : text12,
    'Kích cỡ ảnh giới thiệu đẹp nhất?' : text13,
    'Quy định về các giấy tờ' : text9,
  }


























